export const list = [
  { id: '1', text: '20%', title: 'APR' },
  { id: '2', text: 'Weekly', title: 'Re-staking Frequency' },
  { id: '3', text: 'YES', title: 'EcoIP Royalties' },
  { id: '4', text: 'YES', title: 'Bonus IP Portions' },
  { id: '5', text: 'YES', title: 'IP-Portions Royalty Returns' },
  { id: '6', text: 'YES', title: 'Liquidity Pool Reward' },
  { id: '7', text: 'TurboBacker', title: 'Status' },
];
